import { FORM_PAGES } from '../Form/types';

export enum FORM_INFO_TYPES {
  CREATED_ACCOUNT = 'CREATED_ACCOUNT',
  SUMMARY = 'SUMMARY',
  FORM_FILL_SUMMARY = 'FORM_FILL_SUMMARY',
  BOOKING_ORDER = 'BOOKING_ORDER',
  BOOKING_ORDER_SUBSCRIPTION = 'BOOKING_ORDER_SUBSCRIPTION',
  BOOKING_HANDLING = 'BOOKING_HANDLING',
  BOOKING_ORDER_RECURRING = 'BOOKING_ORDER_RECURRING',
  FORM_QUESTIONS = 'FORM_QUESTIONS',
  BROWSER_NOT_SUPPORTED = 'BROWSER_NOT_SUPPORTED',
  FORMS_FILLED = 'FORMS_FILLED'
}

export const FORM_INFO_COMPONENT_TYPES = {
  CREATED_ACCOUNT: {
    title: 'formInfoTypes.createdAccount.title',
    body: 'formInfoTypes.createdAccount.body',
    registerAs: ''
  },
  SUMMARY: {
    title: 'formInfoTypes.summary.title',
    body: '',
    registerAs: 'SELECTED_DEFAULT_PAYMENT_METHOD'
  },

  BOOKING_ORDER: {
    title: 'formInfoTypes.bookingOrder.title',
    body: 'formInfoTypes.bookingOrder.body',
    registerAs: ''
  },

  BOOKING_ORDER_RECURRING: {
    title: 'formInfoTypes.bookingOrderRecurring.title',
    body: 'formInfoTypes.bookingOrderRecurring.body',
    registerAs: ''
  },

  BOOKING_ORDER_SUBSCRIPTION: {
    title: 'formInfoTypes.bookingOrderSubscription.title',
    body: 'formInfoTypes.bookingOrderSubscription.body',
    registerAs: ''
  },

  BOOKING_HANDLING: {
    title: 'formInfoTypes.bookingHandling.title',
    body: 'formInfoTypes.bookingHandling.body',
    registerAs: ''
  },

  FORM_QUESTIONS: {
    title: 'formInfoTypes.formQuestions.title',
    body: '',
    registerAs: ''
  },

  BROWSER_NOT_SUPPORTED: {
    title: 'formInfoTypes.browserNotSupported.title',
    body: 'formInfoTypes.browserNotSupported.body',
    registerAs: ''
  },

  FORM_FILL_SUMMARY: {
    title: 'formInfoTypes.formFillSummary.title',
    body: '',
    registerAs: ''
  },

  FORMS_FILLED: {
    title: 'formInfoTypes.formsFilled.title',
    body: 'formInfoTypes.formsFilled.body',
    registerAs: ''
  }
} as const;

export enum FORM_INFO_FIELD_TYPES {
  PRODUCT = 'PRODUCT',
  PETS = 'PETS',
  DATE = 'DATE',
  DATE_UNTIL = 'DATE_UNTIL',
  PRICE = 'PRICE',
  MULTI_PRICE = 'MULTI_PRICE',
  DISCOUNT_SUBSCRIPTION = 'DISCOUNT_SUBSCRIPTION',
  VARIATIONS = 'VARIATIONS',
  APPLIED_DISCOUNT = 'APPLIED_DISCOUNT'
}

export const FORM_INFO_COMPONENT_FIELD_TYPES = {
  PRODUCT: {
    title: `{{productType}}`,
    desciption: ''
  },
  VARIATIONS: {
    title: 'formInfoFieldTypes.variations.title',
    desciption: ''
  },
  PETS: {
    title: 'formInfoFieldTypes.pets.title',
    description: ''
  },
  DATE: {
    title: `{{slot}}`,
    description: ''
  },
  DATE_UNTIL: {
    title: 'formInfoFieldTypes.dateUntil.title',
    description: ''
  },
  PRICE: {
    title: 'formInfoFieldTypes.price.title',
    description: ''
  },
  MULTI_PRICE: {
    title: 'formInfoFieldTypes.multiPrice.title',
    description: ''
  },
  DISCOUNT_SUBSCRIPTION: {
    title: 'formInfoFieldTypes.discountSubscription.title',
    description: 'formInfoFieldTypes.discountSubscription.description'
  },
  APPLIED_DISCOUNT: {
    title: 'formInfoFieldTypes.appliedDiscount.title',
    description: ''
  }
} as const;

export enum FORM_INFO_SLOT_TYPES {
  SLOT = 'SLOT',
  MULTI_SLOT = 'MULTI_SLOT',
  MULTI_DAY = 'MULTI_DAY',
  RECURRENCE = 'RECURRENCE',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export const FORM_INFO_COMPONENT_SLOT_TYPES = {
  SLOT: {
    buttonErrorTitle: 'formInfoSlotTypes.slot.buttonErrorTitle',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'formInfoSlotTypes.slot.dateTitle'
  },
  MULTI_SLOT: {
    buttonErrorTitle: 'formInfoSlotTypes.multiSlot.buttonErrorTitle',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'formInfoSlotTypes.multiSlot.dateTitle'
  },
  MULTI_DAY: {
    buttonErrorTitle: 'formInfoSlotTypes.multiDay.buttonErrorTitle',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'formInfoSlotTypes.multiDay.dateTitle'
  },
  RECURRENCE: {
    buttonErrorTitle: 'formInfoSlotTypes.recurrence.buttonErrorTitle',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'formInfoSlotTypes.recurrence.dateTitle'
  },
  SUBSCRIPTION: {
    buttonErrorTitle: 'formInfoSlotTypes.subscription.buttonErrorTitle',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'formInfoSlotTypes.subscription.dateTitle'
  },
  FORMS_FILLED: {
    buttonErrorTitle: 'formInfoSlotTypes.formsFilled.buttonErrorTitle',
    previousPage: FORM_PAGES.FORM_FILL_SUMMARY,
    dateTitle: 'formInfoSlotTypes.formsFilled.dateTitle'
  }
} as const;

export enum FORM_INFO_PAYMENT_DESCRIPTION {
  NO_CHARGE = 'NO_CHARGE',
  POSTPAID = 'POSTPAID'
}

export const FORM_INFO_COMPONENT_PAYMENT_DESCRIPTION = {
  NO_CHARGE: 'formInfoPaymentDescription.noCharge',
  POSTPAID: 'formInfoPaymentDescription.postpaid'
} as const;
